import React from 'react'
import PropTypes from 'prop-types'

import Box from '../../Box'

const ScrollableSection = (props) => {
  const { children, ...restProps } = props

  return (
    <Box flexDirection="column" maxHeight={300} overflowY="auto" {...restProps}>
      {children}
    </Box>
  )
}

ScrollableSection.propTypes = {
  children: PropTypes.node,
}

export default ScrollableSection
